<template>
    <div>
   <slot></slot>
    </div>
</template>

<script>

    export default {
        name: 'tabs-component',
        props: {
            tabs: Array,
            activeTab: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                active: 0
            }
        },
        methods: {
            handleClick(index) {
                this.active = index;
                this.$emit('update:active', index)
            },
        },
        created() {
            this.active = this.activeTab;
        }
    }
</script>

<style scoped>

</style>
